import Vue from "vue";
import VueRouter from "vue-router";
import VueCookies from "vue-cookies";
import routes from "./routes";
Vue.use(VueRouter);
Vue.use(VueCookies);
import moment from "moment";

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("user");

  //const isLoggedIn = this.$cookies.get("accesstoken");

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({ name: "LoginKolegji" });
    } else {
      next();
    }
  } else {
    next();
  }
});
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY hh:mm");
  }
});

export default router;
